import ContainerIncomesRoutes from "./container_incomes.js";
import ContainerOutcomesRoutes from "./container_outcomes.js";
import QueryContainerIncomesRoutes from "./query_container_incomes.js";

import QueryContainerOutcomesRoutes from './query_container_outcomes';
export default [
  ...ContainerIncomesRoutes,
  ...ContainerOutcomesRoutes,
  ...QueryContainerIncomesRoutes,
  ...QueryContainerOutcomesRoutes,
];
